import { useState } from 'react';
import usePlatformBrandKits from '@/hooks/usePlatformBrandKits';
import { MediaPickerTab, UseMediaPickerStateReturn } from '@/Pages/BrandKit/types';
import { useRemoteApp } from '@/context/RemoteAppContext/RemoteAppContext';

export function useMediaPickerState(): UseMediaPickerStateReturn {
  const { isRemoteApp } = useRemoteApp();
  // showUploadsOnly assumes that 'uploads' is always the default tab — if you change
  // the default activeTab, ensure 'uploads' is still the default when showUploadsOnly is true
  const [activeTab, setActiveTab] = useState<MediaPickerTab>('uploads');
  const { brandKits, selectedBrandKitId: globalKitId } = usePlatformBrandKits();
  const [localBrandKitId, setActiveBrandKitId] = useState<string | undefined>();

  const activeBrandKitId = localBrandKitId ?? globalKitId;
  const activeKit = brandKits.find(kit => kit.id === activeBrandKitId) ?? brandKits[0];

  return {
    activeTab,
    setActiveTab,
    activeBrandKitId,
    setActiveBrandKitId,
    brandKits,
    activeKit,
    showUploadsOnly: isRemoteApp
  };
}
